import { Reveal } from "@/components/Reveal";

export function SectionHead({ eyebrow, title, description, align = "left", testid }) {
  return (
    <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid={testid}>
      <p className="eyebrow mb-4">{eyebrow}</p>
      <h2 className="font-jakarta font-extrabold tracking-tight text-rw-text text-2xl sm:text-3xl lg:text-4xl leading-[1.12] text-balance">
        {title}
      </h2>
      {description && <p className="mt-5 text-base sm:text-lg text-rw-muted leading-relaxed">{description}</p>}
    </Reveal>
  );
}
